/** BE 요청 상한 — GetErpInboundsRequest @Max(1000). 전량 조회는 이 크기로 구간을 나눠 받는다(LOGISPRD-15268). */
export const ERP_INBOUNDS_FETCH_SIZE = 1000
